import { Explainer } from '../../components/Explainer'
import { CheckInCadenceCard } from '../deployment/CheckInCadenceCard'
import { CredentialPeriodCard } from './CredentialPeriodCard'

/**
 * How often the fleet talks to this server, and what it collects when it does.
 *
 * The two numbers here are one answer and were on two tabs. A credential rotates only at a successful
 * check-in, so the cadence decides how many chances a device gets to pick up its next credential
 * before the old one expires, and the lifetime decides how many chances it needs. An operator reading
 * either alone is reading half of "how long can this laptop be in a drawer".
 *
 * Nothing here can be recovered by clicking again on the machine's behalf, which is why both cards ask
 * before they act - and why both say, in the words the server sent rather than words this screen
 * computed, that nothing is revoked early.
 */
export function CheckInPage() {
  return (
    <>
      <p className="lede">
        How often every device polls this server, and how long the credential it polls with lasts.
        Together they decide how long a machine can be switched off and still come back.
      </p>

      <CheckInCadenceCard />
      <CredentialPeriodCard />

      <Explainer summary="How long can a machine be off and still come back?" data-testid="checkin-explainer">
        <p className="muted" style={{ marginTop: 0 }}>
          As long as its credential lasts. A device is handed its next credential at a check-in, and it
          keeps the old one for a further fortnight so it has time to collect the new one. Nothing is
          revoked early: a machine that has been off for months authenticates the moment it is switched
          on, provided its old credential has not actually expired.
        </p>
        <p className="muted">
          That fortnight is the only safety net, which is why an expiry is never stamped at issue. A
          credential that expired on a shelf could not be rescued from here — rotation happens
          only on a successful check-in, and a device with an expired credential never gets one.
        </p>
        <p className="hint">
          A device that comes back after its credential has gone is refused with a retryable answer and
          the reason in the body, so the agent keeps trying rather than giving up. Enrolling it again
          from a kit is the way back.
        </p>
      </Explainer>
    </>
  )
}
